module.exports = __webpack_public_path__ + "webpc/img/icon_no_ing.2b464440.png";